import React, { PureComponent } from "react";
import { Icon } from "semantic-ui-react";
import html2canvas from "html2canvas";

import { audienceByCountryTabpanes, getAudienceByCountryChart } from "./utils";
import { ReactComponent as MoreOptions } from "../../../assets/svg/menu.svg";
import { downloadCSVData, downloadCanvasWithTitle } from "../Dashboard/Charts/utils";
import ChartOptionsSidebar from "../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import ChartName from "../Dashboard/Charts/ChartName";
import FBPageSelector from "./FBPageSelector";
import DeleteWidget from "../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/chevron.svg";
import DimmerComponent from "../Dashboard/DimmerComponent";
import { ChartFilterIcon } from "../Dashboard/Charts/ChartFilterOptions";
import { countryColorList } from "../../../lib/countryList";
import { ReactComponent as MiniMize } from "../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../Dashboard/Charts/DownloadChart";

class AudienceByCountries extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
        };

        this.chart = React.createRef();
    }

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    { name: "PNG", downloadFn: this.downloadPNG, showLoader: true },
                ]}
            />
        );
    }

    downloadPNG = (cb) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        // this.setState({ downloading: true });
        if (this.chart?.current)
            return html2canvas(this.chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    // this.setState({ downloading: false });
                    cb & cb();
                    downloadCanvasWithTitle(canvas, this.props.widget?.name || "Audience by Country");
                },
            );
    };

    getCountryName = (code) => {
        let nameArr = countryColorList.find((country) => country.code.toLowerCase() === code);
        return nameArr.country;
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        this.setState({ downloading: true });
        let data = this.props.data?.audienceByCountries?.data;
        let columns = [["Country"], ["Counts"]];

        data = Object.fromEntries(Object.entries(data).sort(([, a], [, b]) => b - a));

        Object.keys(data).map((countryCode) => columns[0].push([this.getCountryName(countryCode)]));
        columns[0].push("Total");
        Object.values(data).map((value) => columns[1].push(value));

        let total = Object.values(data)
            .map((x) => x)
            .reduce((x, y) => x + y, 0);

        columns[1].push(total);

        let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));

        this.setState({ downloading: false });
        downloadCSVData(csvFmt, this.props.widget?.name || "Audience by Country");
    };

    increment = () => {
        if (this.props.fbSelectedPageIds.length === 1) return;
        let index;
        this.props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === this.props.selectedFbPage?.value) index = ind;
        });
        if (index === this.props.fbSelectedPageIds.length - 1) this.props.setSelectedFbPage(this.props.fbSelectedPageIds[0]);
        else this.props.setSelectedFbPage(this.props.fbSelectedPageIds[index + 1]);
    };

    decrement = () => {
        if (this.props.fbSelectedPageIds.length === 1) return;
        let index;
        this.props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === this.props.selectedFbPage?.value) index = ind;
        });
        if (index === 0) this.props.setSelectedFbPage(this.props.fbSelectedPageIds[this.props.fbSelectedPageIds.length - 1]);
        else this.props.setSelectedFbPage(this.props.fbSelectedPageIds[index - 1]);
    };

    getChart() {
        let chart = audienceByCountryTabpanes[0].chartsList[0];
        let Component = getAudienceByCountryChart(chart).component;
        return (
            <>
                <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={this.chart}>
                    {!this.props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-left ${this.props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}
                            onClick={this.decrement}>
                            <ArrowIcon />
                        </div>
                    )}
                    <div className="chart-area">
                        {!this.props.isFBPage && this.props.selectedFbPage && (
                            <FBPageSelector
                                selectedFbPage={this.props.selectedFbPage}
                                setSelectedFbPage={this.props.setSelectedFbPage}
                                fbSelectedPageIds={this.props.fbSelectedPageIds}
                                widgetContainerRef={this.props.widgetContainerRef}
                            />
                        )}
                        <Component
                            showGridLines={this.props.showGridLines}
                            showLegend={this.props.showLegend}
                            graph_type={this.props.graph_type}
                            data={this.props.data}
                            isNoData={this.isNoData}
                            showLabel={this.props.showLabel}
                            resizedCount={this.props.resizedCount}
                            isFBPage={this.props.isFBPage}
                            widgetContainerRef={this.props.isFBPage ? this.chart : this.props.widgetContainerRef}
                            pageStatus={this.props.pageStatus}
                        />
                    </div>
                    {!this.props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-right ${this.props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}
                            onClick={this.increment}>
                            <ArrowIcon />
                        </div>
                    )}
                </div>
            </>
        );
    }

    isNoData = () => {
        if (this.props.pageStatus) return true;
        return this.props.data && Object.keys(this.props.data.audienceByCountries?.data).length === 0 ? true : false;
    };

    render() {
        const elements = (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        isFacebook
                        name={this.props.widget?.name || "Audience by Country"}
                        info="This is an aggregated demographic data based on country information that users provide in their Facebook profiles. This metric is estimated by Facebook / Meta."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.isNoData() && (
                            <div className="chart-type">
                                <span
                                    data-html2canvas-ignore="true"
                                    onClick={() => this.props.changeGraphType("pie")}
                                    className={this.props.graph_type === "pie" || this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="pie chart" />
                                </span>
                                <span
                                    data-html2canvas-ignore="true"
                                    onClick={() => this.props.changeGraphType("bar")}
                                    className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isFBPage &&
                            !this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    data-html2canvas-ignore="true"
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && !this.isNoData() && this.renderDownloadButton(this.isNoData())}
                        {
                            <>
                                {(this.props.isPublic && this.isNoData()) || this.props.isFBPage ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }

                        {this.props.isPublic && this.isNoData() ? null : (
                            <MoreOptions
                                className={this.isNoData() && this.props.isFBPage ? "pointer-disabled" : "more-options"}
                                onClick={(e) => this.props.changeShowMoreOptions(e)}
                            />
                        )}
                    </div>

                    {this.props.showMoreOptions && (
                        <ChartOptionsSidebar
                            data-html2canvas-ignore="true"
                            showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                            changeShowMoreOptions={this.props.changeShowMoreOptions}>
                            {!this.isNoData() && (
                                <>
                                    {/* <TabSelector options={chartOptions} value={0} onChange={() => null} /> */}
                                    {/* <CustomCheckBox checked={this.props.showUniqueLines} onClick={this.props.changeShowUniqueLine} label="Show Unique" /> */}

                                    <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />

                                    <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Label" />
                                    <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                                    {/* <FBIntervalSelector
                                        aggs_val={this.props.aggs_val}
                                        appliedFilter={this.props}
                                        handleIntervalChange={this.props.handleIntervalChange}
                                        duration={this.props.duration}
                                    /> */}
                                </>
                            )}
                            {!this.props.isFBPage &&
                                !this.props.isPublic &&
                                !this.props.isStandardDashboard &&
                                !this.props.isResearchDashboard &&
                                this.props.dashboardPageType !== "temporaryInsights" &&
                                this.props.dashboardPageType !== "temporary" && (
                                    <>
                                        <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                            <span>Chart Configuration</span>
                                            <Settings />
                                        </div>
                                        <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                            <span>Clone Chart</span>
                                            <CloneIcon />
                                        </div>
                                        <DeleteWidget onClick={this.props.deleteWidget} />
                                    </>
                                )}
                        </ChartOptionsSidebar>
                    )}
                </div>
                {this.getChart()}
                {(this.state.downloading || !this.props.selectedFbPage || this.props.loading) && <DimmerComponent />}
            </>
        );

        return this.props.isFBPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
    }
}

export default AudienceByCountries;
